import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://fetiakfllzxwibqzfedh.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZldGlha2ZsbHp4d2licXpmZWRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI3NTE2MzcsImV4cCI6MjA4ODMyNzYzN30.rl6uFcGCVQqK-6XkkkUCLV6kkXc8QHjEiiyIzRxp5-4'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})